import React from "react";
import { Trash2 } from "lucide-react";

/**
 * Delete Context Menu
 * Appears when clicking the three-dot menu icon in history items
 */
export default function DeleteMenu({ onDelete, isDark }) {
  return (
    <div
      className={`rounded-xl shadow-lg p-6 w-[170px] ${
        isDark ? "bg-[#303030]" : "bg-[#FFFFFF]"
      }`}
      style={{
        border: isDark
          ? "1px solid rgba(255, 255, 255, 0.15)"
          : "1px solid rgba(13, 13, 13, 0.1)",
        boxShadow:
          "0 4px 6px -4px rgba(0, 0, 0, 0.10), 0 10px 15px -3px rgba(0, 0, 0, 0.10)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={onDelete}
        className={`w-full flex items-center gap-1.5 px-10 py-8 rounded-md transition-all duration-200 ${
          isDark
            ? "hover:bg-[#E02E2A]/10 active:bg-[#E02E2A]/20"
            : "hover:bg-[#E02E2A]/2 active:bg-[#E02E2A]/4"
        }`}
      >
        <Trash2
          className="w-[18px] h-[18px]"
          style={{ color: isDark ? "#E02E2A" : "#E02E2A" }}
          strokeWidth={2}
        />
        <span
          className={`font-medium text-[13px] leading-[1.38em] tracking-[-0.62%] text-[#E02E2A]`}
        >
          Delete
        </span>
      </button>
    </div>
  );
}
